// Module
var code = "<div class=\"toolbar\"></div> <div class=\"dashboard-page-container\"> <div class=\"side-menu card\"></div> <div class=\"visualizations\"></div> </div> ";
// Exports
export default code;